export default {
  loginTitle: 'TraceHub',
  loginBtn: 'LOG IN',
  logout: 'Logout',
  logoTip: 'Do you want to log out?',
  oktaError: 'You are not authorized, pls contact the administration',
  shortcutKey: '*Press shortcut key to login.',
  noChannelInfo: 'Please register your RF device with channel info.',
  deviceNotRegisteredTitle: 'Device Not Registered',
  deviceNotRegisteredContent:
    'This RF Device is not registered in NDC system. Please register with your device code and Mac address before next login.'
}
